/* eslint-disable react/jsx-no-bind */
/* eslint-disable max-classes-per-file */
import * as React from "react";
import { AppShape, DocShape } from "@eave/shared/types/api";

import { createDocumentFieldsDiff } from "underwriter_dashboard/shared/Documents/api-helpers";
import DocRender from "./DocRender";
import DocDataForm from "./Documents/DocDataForm";
import { DocumentOwnerOption } from "./Documents/types";

const styles = require("./docUploaderStyles.module.scss");

interface DocChangerModuleProps {
  app: AppShape;
  showFormOnly?: boolean; // do not show the Document (<DocRender>)
  hideButton?: boolean; // hide the form's own submit button for when you want to save via footer
  doc: DocShape;
  ownerOptions: DocumentOwnerOption[];
  onSave: Function;
  updateParentState?: Function;
}

export const getInitialState = (doc: DocShape) => {
  if (!doc) {
    return {
      type: null,
      owner_entity_type: null,
      owner_entity_id: null,
      borrower_entity: null,
      revised_filename: null,

      // document fields
      newVisibility: null,
      newUsed: null,
    };
  }
  return {
    // fields on document
    type: doc.type,
    owner_entity_type: doc.owner_entity_type,
    owner_entity_id: doc.owner_entity_id,
    borrower_entity: doc.borrower_entity,
    revised_filename: doc.filename,

    // document fields
    newVisibility: doc.visible,
    newUsed: doc.used,
  };
};

class DocChangerModule extends React.Component<DocChangerModuleProps, any> {
  updateDocData(values) {
    const {
      borrower_entity,
      owner_entity_id,
      owner_entity_type,
      revised_filename,
      type,
      newVisibility,
      newUsed,
    } = values;

    const { doc } = this.props;

    const updatedDocument = {
      ...doc,
      borrower_entity,
      owner_entity_id,
      owner_entity_type,
      revised_filename,
      type,
    };

    const documentFieldsUpdateDiff = createDocumentFieldsDiff(
      this.props.doc,
      values,
      newUsed,
      newVisibility,
    );

    this.props.onSave(updatedDocument, documentFieldsUpdateDiff);
  }

  componentDidMount() {
    document.documentElement.scrollTop = 0;
  }

  render() {
    const { app, showFormOnly, hideButton, doc, ownerOptions, updateParentState } = this.props;

    return (
      <div className={styles.docChanger}>
        {!showFormOnly && (
          <div className={styles.flexColumnWide}>
            <DocRender doc={doc} />
          </div>
        )}
        <div className={showFormOnly ? styles.docEntrySection : styles.flexColumnNarrow}>
          <DocDataForm
            app={app}
            hideButton={hideButton}
            key={doc.id}
            doc={doc}
            ownerOptions={ownerOptions}
            initialValues={{
              // fields on document
              type: doc.type,
              owner_entity_type: doc.owner_entity_type,
              owner_entity_id: doc.owner_entity_id,
              borrower_entity: doc.borrower_entity,
              revised_filename: doc.filename,

              // document fields
              newVisibility: doc.visible,
              newUsed: doc.used,
              newOwner: JSON.stringify({
                owner_entity_type: doc.owner_entity_type,
                owner_entity_id: doc.owner_entity_id,
              }),
            }}
            onSubmit={this.updateDocData.bind(this)}
            updateParentState={updateParentState}
          />
        </div>
      </div>
    );
  }
}

export default DocChangerModule;
